/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { STORE_TOKEN } from 'ng/root-store/root-store.tokens';
import { setFaults } from 'ng/modules/virtual-service/store/virtual-service.actions';
import { VIRTUAL_SERVICE_STATE_SERVICE_TOKEN } from '../../../../downgrade-services.tokens';
import './virtualservice-detail.less';

/**
 * @ngdoc component
 * @name  virtualserviceDetail
 * @param  {VirtualService} loadedVirtualService
 * @description
 *
 *     VirtualService detail page containing the VirtualService child pages.
 */
class VirtualserviceDetailController {
    constructor(
        $scope,
        $rootScope,
        myAccount,
        virtualServiceStateService,
        store,
    ) {
        this.$scope_ = $scope;
        this.myAccount = myAccount;
        this.store = store;

        // TODO: this service is needed to share this instance of VS item
        // across modules. To be removed when item infrastructure updated to Store.
        this.virtualServiceStateService = virtualServiceStateService;

        // Emulating what is provided on $rootScope from app.js for child pages, since this is
        // now using an isolated scope. TODO: remove when possible.
        Object.assign(
            this.$scope_,
            _.pick(
                $rootScope,
                '$location',
                '$state',
                '$stateParams',
                'timeouts',
                'allowed',
            ),
        );
    }

    $onInit() {
        const { loadedVirtualService: vs } = this;

        this.$scope_.vs = vs;
        this.virtualServiceStateService.virtualService = vs;

        /** @deprecated */
        this.$scope_.VirtualService = vs;

        vs.bind('itemLoadSuccess', this.handleVirtualserviceUpdate);
    }

    $onDestroy() {
        this.loadedVirtualService.destroy();
    }

    /**
     * Handle the 'itemLoadSuccess' event on the VS. Update the root store with faults by VS ID.
     */
    handleVirtualserviceUpdate = () => {
        const { id: vsId, data } = this.loadedVirtualService;
        const { faults = {} } = data;

        this.store.dispatch(setFaults({
            payload: {
                faults,
                vsId,
            },
        }));
    };
}

VirtualserviceDetailController.$inject = [
    '$scope',
    '$rootScope',
    'myAccount',
    VIRTUAL_SERVICE_STATE_SERVICE_TOKEN,
    STORE_TOKEN,
];

angular.module('aviApp').component('virtualserviceDetail', {
    bindings: {
        loadedVirtualService: '<resolveVS',
    },
    controller: VirtualserviceDetailController,
    templateUrl: 'src/components/pages/item-detail/virtualservice-detail/' +
        'virtualservice-detail.html',
});
